module.exports = __webpack_public_path__ + "static/media/eve-dai.dbd01951.svg";